import R from 'ramda';
import { compareJSONObjects } from '../../../../utils';

const getChangeRequestsGroup = (blockChangeRequests) => {
  const changeRequestsGroup = [];
  while (blockChangeRequests.length > 0) {
    let block = blockChangeRequests[0];
    const group = R.filter(
      (item) => compareJSONObjects(item.changes, block.changes),
      blockChangeRequests
    );
    blockChangeRequests = R.filter(
      (item) => !compareJSONObjects(item.changes, block.changes),
      blockChangeRequests
    );
    changeRequestsGroup.push(group);
  }

  return changeRequestsGroup.map((group) => {
    const users = [];
    const userNames = [];
    group.forEach((changeRequest) => {
      users.push(changeRequest.user);
      if (changeRequest.user) {
        userNames.push(changeRequest.user.name);
      }
    });

    return {
      changes: group[0].changes,
      users,
      userNames: userNames.join(', '),
    };
  });
};

export default getChangeRequestsGroup;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/getChangeRequestsGroup.js